import { TemplateAPI } from "./template";
import { ProductAPI } from "./product";
import { MediaAPI } from "./media";
import { TranslationAPI } from "./translation";
import { GroupAPI } from "./group";
import { TabAPI } from "./tab";
import { TagAPI } from "./tag";
import { CollectionAPI } from "./collection";


const template = new TemplateAPI();
const product = new ProductAPI();
const media = new MediaAPI();
const translation = new TranslationAPI();
const group = new GroupAPI();
const tab = new TabAPI();
const tag = new TagAPI();
const collection = new CollectionAPI();
class Api
{
    get template() { return template; }
    get product() { return product; }
    get media() { return media; }
    get translation() { return translation; }
    get group() { return group; }
    get tab() { return tab; }
    get tag() { return tag; }
    get collection() { return collection; }
}

export default new Api();


// WEBPACK FOOTER //
// ./src/services/api.ts